var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"full-review-modal"},[_c('inner-modal-close-button'),_c('div',{staticClass:"full-review-modal__content",domProps:{"innerHTML":_vm._s(_vm.review.description)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }